import { Send } from 'lucide-react';
import { LINK_EXPIRY_MINUTES } from '@/components/auth/constants';
import { AuthBackLink } from '@/components/auth/AuthBackLink';

type CheckEmailContext = 'register' | 'reset';

interface CheckEmailContentProps {
  context: CheckEmailContext;
  email: string;
}

const COPY: Record<
  CheckEmailContext,
  { subtitle: string; bodyPrefix: string; bodySuffix: string }
> = {
  register: {
    subtitle: 'Ikuti tautan pada email untuk memverifikasi akun Anda.',
    bodyPrefix: 'Tautan verifikasi dikirim ke',
    bodySuffix: `Tautan berlaku ${LINK_EXPIRY_MINUTES} menit.`,
  },
  reset: {
    subtitle: 'Ikuti tautan pada email untuk membuat password baru.',
    bodyPrefix: 'Tautan reset dikirim ke',
    bodySuffix: `Tautan berlaku ${LINK_EXPIRY_MINUTES} menit.`,
  },
};

export function CheckEmailContent({ context, email }: CheckEmailContentProps) {
  const copy = COPY[context];

  return (
    <div className="text-center">
      <div className="mb-6 flex justify-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50">
          <Send className="h-7 w-7 text-primary-500" />
        </div>
      </div>
      <h1 className="mb-2 text-xl font-bold text-foreground">Cek Email Anda</h1>
      <p className="mb-4 text-sm text-muted-foreground">{copy.subtitle}</p>
      <p className="text-sm text-muted-foreground">
        {copy.bodyPrefix} <strong>{email}</strong>. {copy.bodySuffix}
      </p>
      <div className="mt-8">
        <AuthBackLink />
      </div>
    </div>
  );
}

export function CheckEmailError() {
  return (
    <div className="text-center">
      <p className="mb-4 text-sm text-destructive">
        Parameter halaman tidak valid. Silakan kembali dan coba lagi.
      </p>
      <AuthBackLink />
    </div>
  );
}
